"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var userAgent_1 = require("./userAgent");

exports.MATCH_QUERY = '(-webkit-video-playable-inline)';
/**
 * iOS < 10 does not support playsinline
 *
 * @param {Document} doc
 * @param {Window} win
 * @returns {boolean}
 */

exports._supportsInlineControls = function (doc, win) {
  // If we are not on iOS, we assume there is support for inline controls.
  if (userAgent_1.isIos(win) === false) {
    return true;
  } // iOS might be emulated through devtools. In that case, inline controls
  // are always supported.
  // (https://git.svt.se/svtplayspelare/svtlib-videoplayer-web/issues/25)


  if (userAgent_1.isWindows(win) || userAgent_1.isMac(win)) {
    return true;
  } // There is a special case for iPad, because it might report that is has
  // no support for webkit-video-playable-inline, but in fact all iPads have
  // support.


  if (userAgent_1.isIpad(win)) {
    return true;
  } // iOS support matchMedia since 5.1, and iPhones or iPods with iOS < 5.1
  // does not support inline controls.


  if (typeof win.matchMedia === 'undefined') {
    return false;
  }

  return win.matchMedia(exports.MATCH_QUERY).matches;
};

exports.supportsResponseURL = function () {
  return typeof XMLHttpRequest !== 'undefined' && 'responseURL' in XMLHttpRequest.prototype;
};

exports.supportsFullUi = function (doc, win) {
  var safariVersion = userAgent_1.getSafariVersion(win);
  var isSupportedSafariVersion = safariVersion && safariVersion.major ? safariVersion.major > 6 : true;
  return isSupportedSafariVersion && exports._supportsInlineControls(doc, win);
};